import { FilterFieldInstruction } from './shared';
export class FilterTextInstruction extends FilterFieldInstruction {
  getDefaults() {
    return {
      width: null
    };
  }
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      width: 'width',
      placeholder: 'placeholder'
    };
    this.attributeMap = {
      'e2e-filter': 'formControlName'
    };
    this.setConfig(config);
  }
  load() {
    return import(/* webpackChunkName: "ui-input-text" */
    /* webpackMode: "lazy" */
    '@common/ui/frontend-shared/input-text').then(m => m.UiInputTextComponent);
  }
}